interface AssistantAvatarProps {
  letter: string;
  color?: string;
  size?: number;
}

const AssistantAvatar = ({ letter, color = "#733fb7", size = 44 }: AssistantAvatarProps) => {
  return (
    <div
      style={{
        width: size,
        height: size,
        borderRadius: "50%",
        backgroundColor: color,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        color: "#fff",
        fontWeight: 700,
        fontSize: size <= 24 ? 10 : 16,
        lineHeight: "20px",
        fontFamily: '"Eudoxus Sans", sans-serif',
        flexShrink: 0
      }}
    >
      {letter}
    </div>
  );
};

export default AssistantAvatar;
